import { useAuth } from "@/contexts/auth-provider/useAuth";

/**
 * Feature flags provistos por el backend.
 *
 * El origen es el endpoint de perfil (`GET /admin/v1/user/profile`), que expone
 * los flags en `data.feature_flags` como un mapa `{ nombre: boolean }`. El
 * `AuthProvider` es el único dueño de esos datos y los publica en el contexto de
 * autenticación; el resto de la app consume únicamente `useFeatureFlag`.
 */

/**
 * Nombres de los feature flags tal como los entrega el backend.
 */
export const FeatureFlagKeys = {
  ALLOW_HOME_METRICS: "allow-home-metrics",
  ALLOW_SMS: "sms-notifications",
} as const;

/**
 * Resuelve un feature flag sin acoplar los componentes a su origen.
 *
 * El valor proviene del contexto de autenticación (perfil del usuario). Si el
 * flag no está presente en el mapa, se considera deshabilitado.
 */
export const useFeatureFlag = (featureFlag: string) => {
  const { featureFlags } = useAuth();

  return { isEnabled: featureFlags?.[featureFlag] ?? false };
};
